/**
 * Catalogue des routes de l'API fournisseur (`/supplier/v1`) appelées par l'onglet de test.
 * Source unique des verbes et chemins : la façade typée et l'aperçu des actions s'appuient dessus.
 */

export type SupplierApiMethod = 'GET' | 'POST' | 'PATCH';

export type SupplierApiRouteId =
  | 'me'
  | 'tickets-list'
  | 'tickets-detail'
  | 'tickets-lines'
  | 'tickets-confirm'
  | 'tickets-line-confirm'
  | 'tickets-line-complete'
  | 'orders-list'
  | 'orders-detail'
  | 'orders-lines'
  | 'orders-confirm'
  | 'billables-list'
  | 'billables-detail'
  | 'billables-lines';

export interface SupplierApiRoute {
  id: SupplierApiRouteId;
  method: SupplierApiMethod;
  /** Les segments `:nom` sont remplacés par les identifiants au moment de l'appel. */
  path: string;
}

export const SUPPLIER_API_ROUTES: SupplierApiRoute[] = [
  { id: 'me', method: 'GET', path: '/supplier/v1/me' },
  { id: 'tickets-list', method: 'GET', path: '/supplier/v1/tickets' },
  { id: 'tickets-detail', method: 'GET', path: '/supplier/v1/tickets/:ticketId' },
  { id: 'tickets-lines', method: 'GET', path: '/supplier/v1/tickets/:ticketId/lines' },
  { id: 'tickets-confirm', method: 'POST', path: '/supplier/v1/tickets/:ticketId/confirm' },
  { id: 'tickets-line-confirm', method: 'POST', path: '/supplier/v1/tickets/:ticketId/lines/:lineId/confirm' },
  { id: 'tickets-line-complete', method: 'PATCH', path: '/supplier/v1/tickets/:ticketId/lines/:lineId/complete' },
  { id: 'orders-list', method: 'GET', path: '/supplier/v1/orders' },
  { id: 'orders-detail', method: 'GET', path: '/supplier/v1/orders/:orderId' },
  { id: 'orders-lines', method: 'GET', path: '/supplier/v1/orders/:orderId/lines' },
  { id: 'orders-confirm', method: 'POST', path: '/supplier/v1/orders/:orderId/confirm' },
  { id: 'billables-list', method: 'GET', path: '/supplier/v1/orders/:orderId/billables' },
  { id: 'billables-detail', method: 'GET', path: '/supplier/v1/orders/:orderId/billables/:billableId' },
  { id: 'billables-lines', method: 'GET', path: '/supplier/v1/orders/:orderId/billables/:billableId/lines' },
];

export function getSupplierApiRoute(id: SupplierApiRouteId): SupplierApiRoute {
  return SUPPLIER_API_ROUTES.find(route => route.id === id);
}

/** Chemin réel d'une route : chaque `:nom` est remplacé par sa valeur. */
export function buildSupplierApiPath(route: SupplierApiRoute, pathParams: Record<string, string>): string {
  return route.path.replace(/:(\w+)/g, (_, name) => encodeURIComponent(pathParams?.[name]?.trim() ?? ''));
}
